module.exports = __webpack_public_path__ + "img/video-poster.3a25068e.png";